<div
  *ngIf="
    !doc.canceled &&
    hasPayments(doc.type) &&
    doc.totalPaid !== 0
  "
>
  <h2
    class="text-success"
    *ngIf="doc.paidInFull; else partiallyPaid"
  >
    {{ 'document-view-public.document-view-status.paid' | translate }}
  </h2>
  <ng-template #partiallyPaid>
    <h2 class="text-warning">
      {{ 'document-view-public.document-view-status.partially-paid' | translate }}
    </h2>
  </ng-template>
</div>

<h2 class="text-danger" *ngIf="doc.canceled">
  {{ 'document-view-public.document-view-status.canceled' | translate }}
</h2>

<h2
  class="text-muted"
  *ngIf="
    !doc.canceled &&
    doc.totalPaid === 0 &&
    (doc.sentSnailMail || isSent(doc))
  "
>
  {{ 'document-view-public.document-view-status.sent' | translate }}
</h2>
